type Props = { size?: number; color?: string };

export function IconArrowUpRight({ size = 13, color = "currentColor" }: Props) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke={color}
			strokeWidth="2.2"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
		>
			<path d="M7 17L17 7" />
			<path d="M9 7h8v8" />
		</svg>
	);
}
